import { updateState } from '@angular-architects/ngrx-toolkit';
import { computed } from '@angular/core';
import { signalStore, signalStoreFeature, withComputed, withMethods, withState } from '@ngrx/signals';
import { withNamedStorage } from '../../common';
import { defaultDomainStateConfig } from '../../functions';
import { IStateConfig } from '../../model';

export interface IMessageState {
  notify: boolean;
  content: string;
  title: string;
}

const initialMessageState: IMessageState = {
  notify: false,
  content: '',
  title: ''
};

const messageStateConfig: IStateConfig = defaultDomainStateConfig({ storeIdentifier: 'message' });

export const MessageStore = signalStore({ providedIn: 'root' }, withBaseMessageStore(initialMessageState, messageStateConfig));

function withBaseMessageStore(initialMessageState: IMessageState, { storeIdentifier }: IStateConfig) {
  return signalStoreFeature(
    withState<IMessageState>(initialMessageState),
    withNamedStorage({ storeIdentifier }),
    withComputed(({ title, content }) => {
      return {
        messageContent: computed<string>(() => {
          return content();
        }),
        messageTitle: computed<string>(() => {
          return title();
        })
      };
    }),
    withMethods((store) => ({
      updateMessage({ content, title }: Pick<IMessageState, 'content' | 'title'>) {
        updateState(store, 'update message', (state) => ({ ...state, content, title }));
      },
      resetMessage() {
        updateState(store, 'reset message', (state) => ({ ...state, content: '', title: '' }));
      }
    }))
  );
}
